import PinDropIcon from "@mui/icons-material/PinDrop";
import { Box, IconButton, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useOpenMaps } from "../../../../hooks/useOpenMaps";
import { INK } from "../../../../theme/tokens";

export const ClickableLocationAddress = ({ address, pl = 4.5 }: { address?: string; pl?: string | number }) => {
	const { openMaps } = useOpenMaps();

	const onClick = async () => {
		if (address) {
			await openMaps(address);
		}
	};

	return address ? (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				pl: pl,
				gap: 0.25,
			}}
		>
			<IconButton size={"small"} onClick={onClick}>
				<PinDropIcon fontSize={"small"} sx={{ fontColor: alpha(INK.SECONDARY, 0.5) }} />
			</IconButton>
			<Typography
				sx={{
					color: alpha(INK.SECONDARY, 0.5),
					borderRadius: "8px",
					fontSize: "12px",
					maxWidth: "100%",
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
				}}
			>
				{address}
			</Typography>
		</Box>
	) : null;
};
